import React from 'react';
import { PopAlert } from 'appkit-react';

class PoorConnectBanner {
  constructor({ silencePeriod, bannerDuration }) {
    this.silencePeriod = silencePeriod;
    this.shouldIgnore = false;
    this.bannerDuration = bannerDuration;
    this.timerId = null;
  }

  setTimer() {
    this.shouldIgnore = true;
  }

  clearTimer() {
    this.shouldIgnore = false;
    if (!this.timerId) {
      return;
    }
    clearTimeout(this.timerId);
    this.timeId = null;
  }

  onPageChange() {
    this.destroy();
    this.clearTimer();
  }

  destroy() {
    const elem = document.getElementById('PopWrapper');
    if (!elem) {
      return;
    }
    elem.parentNode.removeChild(elem);
  }

  alert() {
    if (this.shouldIgnore) {
      return null;
    }

    this.setTimer();
    setTimeout(() => this.clearTimer(), this.silencePeriod);
    this.timerId = setTimeout(() => this.destroy(), this.bannerDuration);

    const message = (
      <div>
        Poor Connection, please try again.
        <div className="a-countdown-wrapper">
          <svg height="16" width="16">
            <circle
              className="a-circle a-countdown animated"
              cx="8"
              cy="8"
              r="4"
              style={{
                animationDuration: `${(this.bannerDuration / 1000).toFixed(
                  1,
                )}s`,
              }}
            />
          </svg>
        </div>
      </div>
    );

    return PopAlert({
      className: 'poor-connection-alert',
      status: 'warning',
      message,
      closeable: true,
    });
  }
}

export const poorConnectionBanner = new PoorConnectBanner({
  bannerDuration: 5000,
  silencePeriod: 300000,
});
